// Bronze
export default [
    {type: "freeplay", to: "$2"},
    {type: "weekly_rakeback", to: "5%"},
    {type: "birthday_bonus", to: "$10 + 10%"},
    {type: "deposit_assist_token", to: "$0.5"},
    {type: "random_boost", from: "UNLOCKED"}
]